var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-select',{attrs:{"value":_vm.waybill_status,"value-key":"key","size":_vm.size,"placeholder":_vm.$t('table.waybill_status'),"clearable":true},on:{"input":function($event){return _vm.change($event)}}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item.id}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d480cb3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/card/components/WayBillStatusSelect.vue
// module id = null
// module chunks = 